import React from 'react';
import ArrModal from '../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './UnsavedChangesModal.scss';

interface UnsavedChangesModalProps {
  showModal: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
  saving?: boolean;
  errorMessage?: string | null;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  showModal,
  onClose,
  onSave,
  onDiscard,
  saving = false,
}) => {
  return (
    <ArrModal
      showModal={showModal}
      headerTitle={t('codingForms.unsavedChangesModal.headerTitle')}
      headerTitleClassName="headline2_size"
      description={t('codingForms.unsavedChangesModal.description')}
      onClose={onClose}
      className="unsaved-changes-modal"
      dataTestId="unsaved-changes-modal"
      buttons={[
        {
          id: 'no-button',
          label: t('common.no'),
          onClick: onDiscard,
          variant: 'secondary',
          disabled: saving,
          dataTestId: 'usc-no-btn',
        },
        {
          id: 'yes-button',
          label: t('common.yes'),
          onClick: onSave,
          variant: 'primary',
          disabled: saving,
          dataTestId: 'usc-yes-btn',
        },
        {
          id: 'cancel-button',
          label: t('codingForms.unsavedChangesModal.cancel'),
          onClick: onClose,
          variant: 'text',
          disabled: saving,
          dataTestId: 'usc-cancel-btn',
        },
      ]}
    />
  );
};

export default UnsavedChangesModal;
